<template>
  <AppErrorShell>
    <slot />
  </AppErrorShell>
</template>
